import { useFlag } from '@/features/unleash';
import { useLocale } from '@/hooks/useLocale';
import { useUserLocale } from '@/hooks/useUserLocale';
import routesGenerator from '@/router/routesGenerator';
import { isSupportedLocale } from '@/utils/locale';
import { useEffect, useMemo } from 'react';
import { pathToAction, replace, NOT_FOUND } from 'redux-first-router';

export function LocaleRedirect() {
  const routeLocale = useLocale();
  const [preferredLocale] = useUserLocale();
  const routesMap = useMemo(() => routesGenerator(), []);
  const { enabled } = useFlag({ name: 'locale-redirect' });
  useEffect(() => {
    const url = new URL(window.location.href);
    const noRedirect = url.searchParams.has('no-redirect');

    if (
      !noRedirect &&
      enabled &&
      isSupportedLocale(preferredLocale) &&
      routeLocale !== preferredLocale
    ) {
      const targetUrl = new URL(window.location.href);
      const safeTargetUrl =
        `/${preferredLocale}` + targetUrl.pathname + targetUrl.search;

      const action = pathToAction(safeTargetUrl, routesMap);
      if (action.type !== NOT_FOUND) {
        replace(safeTargetUrl);
      }
    }
  }, [routeLocale, preferredLocale, routesMap, enabled]);
  return <></>;
}
